import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { Footer } from '../../../components/footer';
import TopUpIncome from './topupIncome';
import BuyTokenIncome from './buytokenIncome';
import { useNavigate } from 'react-router-dom';

const StakingWalletHistory = () => {
   const [activeTab, setActiveTab] = useState('Buy Token');
   const navigate = useNavigate()
  
    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }
  return (
    <>
    <div className="mainContent">
        <div className="pageContent def-py-30">
            <div className='container'>
                  <div className="appPagetitle d-flex g-10 align-items-center">
                      <button className='btn btnBack' onClick={()=>navigate('/staking-wallet')}>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                      </button>
                      <span>{activeTab} History</span>
                  </div>
                
                <div className='row'>
                    <div className="col-lg-12">
                       
                        
                        <div className="appcard mb-4 px-0 pb-2 cardbg">
                            <div className="cardHeader border-bottom-0 px-4 pb-0">
                                <Nav pills className='mypillsTabs'>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === 'Buy Token' })}
                                            onClick={() => { toggle('Buy Token'); }}
                                        >
                                            Buy Token History
                                        </NavLink>
                                    </NavItem>
                                   
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === 'Topup' })}
                                            onClick={() => { toggle('Topup'); }}
                                        >
                                            Top-up Income
                                        </NavLink>
                                    </NavItem>                                    
                                </Nav>
                            </div>
                            <div className="tabcnt">
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="Buy Token">
                                       <BuyTokenIncome />
                                    </TabPane>
                                    
                                    <TabPane tabId="Topup">
                                        <TopUpIncome />
                                    </TabPane>                                    
                                </TabContent>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer />
    
</>
  )
}

export default StakingWalletHistory;